module.exports = {
    fr: {
        meta: {
            title: "Demander une estimation du prix",
            description: "Formulaire de réservation à remplir pour recevoir un devis.",
        },
        eyebrow: "Étape 1 sur 3",
        head: "Nous avons bien reçu votre demande",
        thanks: "Nous vous remercions pour votre confiance.",
        email: "Votre devis est en cours de préparation. Vous recevrez d'ici quelques minutes une proposition par email à l'adresse",
        spam: "Rien reçu après quelques minutes ? Vérifiez vos courriers indésirables ou contactez-nous.",
    },
    en: {
        meta: {
            title: "Request a price quote",
            description: "Reservation form to fill out to receive a quote.",
        },
        eyebrow: "Step 1 of 3",
        head: "We have received your request",
        thanks: "We thank you for your confidence.",
        email: "Your quote is being prepared. Within a few minutes, you will receive a proposal by email at",
        spam: "Nothing after a few minutes? Check your spam folder or contact us.",
    },
    ru: {
        meta: {
            title: "Запрос цены",
            description: "Заполните форму, чтобы получить расчет стоимости поездки.",
        },
        eyebrow: "Шаг 1 из 3",
        head: "Мы получили ваш запрос",
        thanks: "Благодарим вас за доверие.",
        email: "Мы готовим расчет стоимости. В течение нескольких минут вы получите предложение по e-mail на адрес",
        spam: "Ничего не пришло через несколько минут? Проверьте папку «Спам» или свяжитесь с нами.",
    },
};
